import Modal from './Modal';
import { useContext } from 'react';
import { LanguageContext } from "../context/LanguageProvider";
import { getErrorMessages } from '../utils/errorMessages';

const ErrorModal = ({ isVisible, onClose, title, content }) => {
    const { t } = useContext(LanguageContext);
    const { ERROR_TITLE, ERROR_MESSAGE } = getErrorMessages(t);

    return (
        <Modal
            isVisible={isVisible}
            title={title || ERROR_TITLE}
            content={content || ERROR_MESSAGE}
            onClose={onClose}
            actions={
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <button onClick={onClose} className="btn-purple">
                        {t('ok')}
                    </button>
                </div>
            }
        />
    );
};

export default ErrorModal;
